import { defineStore } from 'pinia'
import type { lineData, loginResponse } from '@/interfaces/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    // token/user are no longer seeded from localStorage: app startup now validates
    // the LINE uid against the server (see validateLoginSession in utils/liff.ts)
    // instead of trusting whatever was cached from a previous session.
    token: '',
    user: null as loginResponse | null,
    liffProfile: JSON.parse(localStorage.getItem('liffProfile') || 'null') as lineData | null,
    liffToken: localStorage.getItem('liffToken') || '',
    // Bearer token returned by authLogin's "key", before OTP is confirmed.
    // Kept separate from `token` so isAuthenticated stays false until OTP
    // succeeds, while still letting axios attach it to the getOtp/confirmOTP
    // calls in between. Not persisted — it's only relevant for the duration
    // of a single login attempt.
    pendingToken: '',
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  actions: {
    loginWithLiff(token: string, profile: lineData) {
      this.liffToken = token
      this.liffProfile = profile

      localStorage.setItem('liffToken', token)
      localStorage.setItem('liffProfile', JSON.stringify(profile))
    },
    setPendingToken(token: string) {
      this.pendingToken = token
    },
    login(token: string, user: loginResponse) {
      this.token = token
      this.user = user
      this.pendingToken = ''

      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
    },
    logout() {
      this.token = ''
      this.user = null
      this.pendingToken = ''
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
  },
})
